/** @format */

import { useEffect } from "react";
import flat from "flat";

const userPartyCreateHook = (partyName, form, parties, initialState) => {
  const agreementFormJson = flat.unflatten(form.values);
  useEffect(() => {
    const [party] = parties?.filter(
      ({ name }) => name === agreementFormJson[partyName].name,
    );

    if (party) {
      const otherField = agreementFormJson[partyName] || {};
      const tempParty = {
        ...otherField,
        type: party.type || "Entity",
        entityType:
          party.companyType ||
          party.entityType ||
          otherField.entityType ||
          "Company",
        name: party.name,
        email: party.email || "",
        pocemail: otherField.pocemail || "",
        signatory: party.signatory || "",
        representative: party.representative || "",
        brandName: party.brandName || "",
        address:
          party.registeredOfficeAddress ||
          party.residenceOf ||
          otherField.address ||
          "",
        corporateAddress: party.corporateOfficeAddress || "",
      };

      form.setValues((prevValues) =>
        flat({
          ...initialState,
          ...flat.unflatten(prevValues),
          [partyName]: tempParty,
        }),
      );

      // Clear error only for fields that actually received a value
      Object.entries(tempParty).forEach(([field, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          form.clearFieldError(`${partyName}.${field}`);
        }
      });
    }
  }, [agreementFormJson[partyName].name]);
};

export default userPartyCreateHook;
